import { Loading } from '@components/common';
import { usageMetricList } from '@src/components/usage-dashboard/atoms';
import { useFetchVideoUsageMetric } from '@src/components/usage-dashboard/hooks/dataFetcherhooks';
import { useMakeExportData } from '@src/components/usage-dashboard/hooks/useMetricSeries';
import UsageMetricCard from '@src/components/usage-dashboard/MetricsPanel/UsageMetricCard/UsageMetricCard';
import { Col, Row } from 'antd';
import Title from 'antd/es/typography/Title';
import React from 'react';
import '../metricpanel.css';

const VideoMetricsPanel = () => {
  const { data: seriesData, isFetching }: any = useFetchVideoUsageMetric({
    enabled: true,
    product: 'EI',
  });

  useMakeExportData({
    seriesData,
    sectionKey: 'ud-video-metric-timeseries',
    title: 'Video Usage Metrics',
  });
  const metricList = Object.keys(usageMetricList).filter(
    (key) => usageMetricList[key].product === 'EI',
  );

  if (isFetching) {
    return <Loading></Loading>;
  }
  return (
    <div>
      <Title level={5} className="titleStyle">
        Video Usage
      </Title>
      <Row gutter={{ xs: 4, md: 8, lg: 12 }} className="rowStyle">
        {metricList.map((metric) => (
          <Col key={metric} xs={24} md={12} lg={12} className="colStyle">
            <UsageMetricCard metric={metric}></UsageMetricCard>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default VideoMetricsPanel;
